export default "__VITE_PUBLIC_ASSET__eedde9af__"